import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "@/shared/lib/bff/client";

export interface Invite {
  email: string;
  status: "pending" | "accepted";
}

export const inviteKeys = {
  mine: () => ["invites", "mine"] as const,
};

async function fetchMyInvites(): Promise<Invite[]> {
  return apiFetch<Invite[]>("/api/invites");
}

export function useMyInvites() {
  return useQuery({
    queryKey: inviteKeys.mine(),
    queryFn: fetchMyInvites,
  });
}

async function sendInvites(
  emails: string[]
): Promise<{ invited: number; message?: string }> {
  return apiFetch<{ invited: number; message?: string }>("/api/invites", {
    method: "POST",
    body: JSON.stringify({ emails }),
  });
}

export function useSendInvites() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (emails: string[]) => sendInvites(emails),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: inviteKeys.mine() }),
  });
}
